import tinycolor from 'tinycolor2';

export const isTransparentColor = (color: string | null) =>
  !color || color === 'transparent' || !tinycolor(color).getAlpha();

export const isTransparentColorFallback = (
  color: string | undefined,
  fallback: string
): string => {
  return !color || isTransparentColor(color) ? fallback : color;
};
